<div class="product-item" (click)="onCardClick(product)">
  <img class="icon" [src]="icon" alt="product icon" />
  <div class="product-info">
    <p class="product-name">
      <span class="ticket-id">{{ product.id }} - </span>{{ product.name }}
    </p>

    @if (!product.event.membership) {
    <!-- <span
      *ngIf="product.sale_date_message"
      [ngClass]="getSaleTagClass(product.sale_date_message)"
      class="sale-tag"
      >
      <ion-icon name="time-outline" class="tag-icon" />
      {{ product.sale_date_message }}
    </span> -->
    @if (!isDirectSale) {
    <div class="product-meta">
      <span class="product-sold">
        <img src="assets/icons/method-payment-icon.svg" class="ticket-icon" />
        <span>
          {{
            translatedPaymentMethods ||
              ("products.direct_sale_label" | translate)
          }}
        </span>
      </span>
    </div>
    }
    <!-- <p class="product-category" *ngIf="isDirectSale">
    {{ "products.category" | translate }} {{ product.category.name }}
  </p> -->
    @if (isDirectSale) {
    <div class="product-meta">
      <span class="product-sold">
        <img src="assets/icons/method-payment-icon.svg" class="ticket-icon" />
        <span>
          {{
            product.pay_at_door
              ? ("payment-product-modal.collection-type.third-party"
                | translate)
              : ("payment-product-modal.collection-type.own" | translate)
          }}
        </span>
      </span>
    </div>
    }
    <div class="product-meta">
      <span class="product-price">
        {{ product.price | arsCurrency }}
      </span>
      <span class="product-sold">
        <img src="assets/icons/ticket-icon.svg" class="ticket-icon" />
        <span>
          {{ product.assistants_verified }}
          {{ "products.verified" | translate }}
        </span>
      </span>
    </div>
    <p class="description-text">
      {{
        "detail-product.valid_from_to"
          | translate
            : {
                from: (product.initial_date | shortDateTime),
                to: (product.finish_date | shortDateTime)
              }
      }}
    </p>
    <app-product-progress-bar
      [product]="product"
      [totalProductsSoldType]="totalProductsSoldType"
      [isInsideCard]="true"
      [isDirectSale]="isDirectSale"
    />
    }
  </div>

  <div
    class="dropdown-button"
    (click)="$event.stopPropagation(); openProductOptionsModal()"
  >
    <ion-icon name="ellipsis-vertical" class="options-icon" />
  </div>
</div>
